module.exports = __webpack_public_path__ + "img/options.bb765b7a.svg";